<template lang="pug">

    div.field

        dropdown-field(
            v-bind:isRequired='isRequired'
            v-bind:label='label'
            v-bind:options='options'
            optionLabel='fullName'
            v-model="id"
        )
            slot

        modal(ref="modal")
            span(slot="header") Person erstellen

            div(slot="content")
                create-form(
                    ref='form'
                    v-bind:companyModels='companies'
                    v-bind:hideAddress='hideAddress'
                    v-bind:hideCompany='hideCompany'
                )

            action-row(v-on:cancel='cancel()' v-on:save='submit' save-type='button' slot="footer")

</template>

<script>
    import * as R from 'ramda'
    import DropdownField from '@/components/form/DropdownField'
    import ActionRow from '@/components/form/ActionRow'
    import Modal from '@/components/app/Modal'
    import CreateForm from './CreateForm'

    //noinspection ReservedWordAsName
    export default {

        components: { ActionRow, CreateForm, DropdownField, Modal },

        computed: {

            companies() {
                return [ this.companyModel ]
            },

            id: {
                get() { return this.value },
                set(value) { this.$emit('input', value ) }
            },

            options() {
                return R.compose(

                    // Option fuer Anzeigen des Modals hinzufuegen
                    R.prepend({ id: -1, fullName: '- Neue Person erstellen -' }),

                    // Fullname fuer Personen erstellen
                    R.map(personModel => ({
                        id: personModel.id,
                        fullName: `${personModel.firstName} ${personModel.lastName}`
                    })),

                    // Personen nach Unternehmen filtern
                    R.filter(R.propEq('company', this.companyModel.id))
                    
                )(this.personModels)
            },

        },

        methods: {

            cancel() {
                // ID zuruecksetzen
                this.id = 0

                // Modal closen
                this.$refs.modal.close()
            },

            persist() {
                this.$refs.form.persist()

                    // Erstellte Person setzen
                    .then(person => this.id = person.id)

                    // Growl/Message/Flash anzeigen
                    .then(() => this.$growl.success('Person wurde erstellt'))

                    // Modal closen
                    .then(() => this.$refs.modal.close())

                    // Fehlermeldung anzeigen
                    .catch(e => this.$growl.fatal('Person konnte nicht erstellt werden', e))
            },

            submit() {
                this.$refs.form.validate().then(R.when(R.equals(true), this.persist))
            }

        },

        props: {

            companyModel: {
                type: Object,
                required: true
            },

            hideAddress: {
                type: Boolean,
                default: false
            },

            hideCompany: {
                type: Boolean,
                default: false
            },

            isRequired: {
                type: Boolean,
                default: false
            },

            label: {
                type: String,
                default: 'Person'
            },

            personModels: {
                type: Array,
                required: true
            },

            value: {
                type: Number,
                required: true
            }

        },

        watch: {

            value(value) {
                R.when(R.equals(-1), this.$refs.modal.show, value)
            }

        }

    }

</script>
